export const BrowserFile = {
	toBase64(file: File) {
		return new Promise<string>((resolve, reject) => {
			const reader = new FileReader();

			reader.addEventListener("error", () => reject(new Error("file read failed")), { once: true });
			reader.addEventListener("load", () => resolve((reader.result as string).split(",")[1]), {
				once: true,
			});
			reader.readAsDataURL(file);
		});
	},
};
